/**
 * Recordings that are not served, and why.
 *
 * GENERATED by tools/composition/build-withheld.mjs from data/decisions/endings-v1.json.
 * Do not edit by hand — edit the decision bundle and regenerate, so that what the app
 * does and what the audit record says cannot drift apart. withheld.test.ts fails if they
 * have.
 *
 * Every id below is there because two independent models, reading the transcript of that
 * recording's last speech island against ending-v1, both concluded it is not
 * the end of a meditation. The bundle holds each model's verdict, its confidence, and the
 * verbatim phrase it quoted as evidence. Disagreement was never resolved by a tiebreak:
 * 17 of 152 candidates went to review and none of them is here.
 *
 * 104 further recordings were judged by both to close and then drift into
 * post-meditation material. Trimming those is a speech edit and nothing has been trimmed;
 * the proposals are recorded in the bundle awaiting a decision.
 *
 * TEMPORARY_CONTENT_HOLDS comes from a separate evidence bundle. These holds do not
 * claim the two-model ending verdict above: they keep content out of consumer sessions
 * while a measured boundary defect awaits review.
 */

export interface WithheldEntry {
  readonly id: string;
  readonly reason: string;
}

/** sha256 of data/decisions/endings-v1.json when this file was generated. */
export const BUNDLE_SHA256 = '19a410e98f208141634727cd6abd9fff38cf9778c448e6b2aaa975a01cdb8a2c';

export const WITHHELD: readonly WithheldEntry[] = [
  { id: "Friday Night Guided Meditation | Ajahn Brahmavamso | 26 May 2017 - 2018-12-19",
    reason: "the last speech island is post-meditation material, so a sit ending here ends wrongly" },
  { id: "Guided Meditation | Ajahn Brahmavamso | 06-01-2007 - 2018-07-29",
    reason: "the last speech island is post-meditation material, so a sit ending here ends wrongly" },
  { id: "Guided Meditation | Ajahn Brahmavamso | 06-05-17 - 2017-05-07",
    reason: "the last speech island is post-meditation material, so a sit ending here ends wrongly" },
  { id: "Guided Meditation | Ajahn Brahmavamso | 08-12-2012 - 2018-10-06",
    reason: "the last speech island is post-meditation material, so a sit ending here ends wrongly" },
  { id: "Guided Meditation | Ajahn Brahmavamso | 11-03-2017 - 2017-03-11",
    reason: "the last speech island is post-meditation material, so a sit ending here ends wrongly" },
  { id: "Guided Meditation | Ajahn Brahmavamso | 14-04-2018 - 2018-04-17",
    reason: "the last speech island is post-meditation material, so a sit ending here ends wrongly" },
  { id: "Guided Meditation | Ajahn Brahmavamso | 15-12-2007 - 2018-08-30",
    reason: "the last speech island is post-meditation material, so a sit ending here ends wrongly" },
  { id: "Guided Meditation | Ajahn Brahmavamso | 17-03-2007 - 2018-08-07",
    reason: "the last speech island is post-meditation material, so a sit ending here ends wrongly" },
  { id: "Guided Meditation | Ajahn Brahmavamso | 19-05-2012 - 2018-09-26",
    reason: "the last speech island is post-meditation material, so a sit ending here ends wrongly" },
  { id: "Guided Meditation | Ajahn Brahmavamso | 2 July 2011 - 2019-06-04",
    reason: "the last speech island is post-meditation material, so a sit ending here ends wrongly" },
  { id: "Guided Meditation | Ajahn Brahmavamso | 26-05-2018 - 2018-05-28",
    reason: "the last speech island is post-meditation material, so a sit ending here ends wrongly" },
  { id: "Guided Meditation | Ajahn Brahmavamso | 4 May 2019 - 2019-05-07",
    reason: "the last speech island is post-meditation material, so a sit ending here ends wrongly" },
];

/** sha256 of data/decisions/content-holds-v1.json when this file was generated. */
export const CONTENT_HOLDS_BUNDLE_SHA256 = '1eff44784a16cc8ebee123026432a3d1733c9011cfcd07067eb49e27b6bd905b';

export const TEMPORARY_CONTENT_HOLDS: readonly WithheldEntry[] = [
  { id: "Friday Night Guided Meditation | Ajahn Brahmavamso | 30 March 2007 - 2019-04-04",
    reason: "classified closing is a sub-threshold transient, with no transcript-supported coming-out speech" },
];

const index: ReadonlySet<string> = new Set(
  [...WITHHELD, ...TEMPORARY_CONTENT_HOLDS].map((w) => w.id),
);

export function isWithheld(recordingId: string): boolean {
  return index.has(recordingId);
}
